import React, {
    useState,
    useEffect,
    useRef
} from 'react';
import { useNavigate, useParams } from "react-router";
import Cookies from "js-cookie";

import { getCustomer, refetchCustomer, refetchBasketData } from "../router";

import LoadingIndicator from './loading-indicator';

export default function Iframe(props) {

    const params = useParams();
    let navigate = useNavigate();
    const { data: customer } = getCustomer();

    const iframeRef = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        const onMessage = (event) => {
            if (!iframeRef.current) return;

            const sourceWindow = iframeRef.current.contentWindow || iframeRef.current.contentDocument?.defaultView;
            if (event.source !== sourceWindow) return;

            if (typeof event.data === "string" && event.data.startsWith("resize:")) {
                const newHeight = Number(event.data.slice(7));
                if (!isNaN(newHeight)) {
                    setHeight(newHeight + 5); // Extra padding
                }
            }

            if (event.data?.type === 'navigate') {
                if (event.data.book_online && params.instanceId) {
                    window.location.href = `/book-online/${params.instanceId}`;
                } else {
                    window.location.href = event.data.url;
                }
            }

            if (event.data?.type === 'update_session') {
                refetchCustomer();
            }

            if (event.data?.type === 'basket_updated') {
                refetchBasketData();
            }
        };

        window.addEventListener("message", onMessage);
        return () => {
            window.removeEventListener("message", onMessage);
        };
    }, []);

    useEffect(() => {
        if (!customer) return;

        // Must match structure in SpektrixSession.php
        const session_data = {
            'customer': customer.email,
            'id': customer.id ?? '',
            'email': customer.email ?? '',
            'firstName': customer.firstName ?? '',
            'lastName': customer.lastName ?? '',
            'priority_events': []
        };

        // If the script in the iframe dispatches the update_session event then reset the cookie and update the session
        // Cookies.set('spektrix_session', JSON.stringify(session_data), { expires: 1 / 24, path: '/'});

        // document.dispatchEvent(
        //     new CustomEvent("sessionUpdate", {
        //         bubbles: true,
        //         composed: true,
        //     }),
        // );

    }), [customer];

    return (
        <>
            {props.hasLoader && height === 0 && (
                <LoadingIndicator type="page" />
            )}

            <iframe
                ref={iframeRef}
                name="SpektrixIFrame"
                id="SpektrixIFrame"
                frameBorder="0"
                src={props.url}
                title={props.title}
                style={{ height: height + 'px', minHeight: height + 'px', width: '100%' }}
            />
        </>
    );
}
